import {Parallax, ParallaxLayer } from '@react-spring/parallax'; // npm install @react-spring/parallax
import './App.css';
import Header from'./component/header';
import LayerThree from './component/layerThree';
import Layer1 from './component/layer1';
import Layer2 from './component/layer2';

function App() {
  return (
    <div className="App">
      <Parallax pages={3}>
      <ParallaxLayer sticky={{ start: 0, end: 1.5 }} style={{zIndex:1,maxHeight:"15%"}} >
          <Header />
        </ParallaxLayer>   
      <ParallaxLayer offset={0} speed={2} style={{backgroundColor:"#E6CAE0"}}>
          <Layer1 />
        </ParallaxLayer>
        <ParallaxLayer offset={1} speed={0.1}  style={{backgroundColor:"#E082CE"}}>
          <Layer2 />
        </ParallaxLayer>
        <ParallaxLayer  offset={2} speed={1.5}  style={{backgroundColor:"#AD65A0"}}>
          <LayerThree />
        </ParallaxLayer>
      </Parallax>
    </div>
  );
}

export default App;
